// ============================================================
// PLATFORM CONFIG - DocNow issuer details for Flow 1 invoices
// (myDATA 2.1 Timologio Paroxis Ypiresion to doctors)
// ============================================================
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { platformConfigAPI } from "../services/api";
import { PageHeader, Card, FormField, ActionBtn } from "../components/Shared";

export default function PlatformConfigPage() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    legalName: "", taxId: "", gemi: "", addressLine: "", city: "",
    postalCode: "", country: "GR", phone: "", email: "",
  });

  const load = async () => {
    try {
      const { data } = await platformConfigAPI.get();
      const d = data?.data || {};
      setForm({
        legalName:   d.legal_name    || "",
        taxId:       d.tax_id        || "",
        gemi:        d.gemi          || "",
        addressLine: d.address_line  || "",
        city:        d.city          || "",
        postalCode:  d.postal_code   || "",
        country:     d.country       || "GR",
        phone:       d.phone         || "",
        email:       d.email         || "",
      });
    } catch (err) {
      console.error("Load platform config error:", err);
      toast.error("Σφάλμα φόρτωσης");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const save = async () => {
    if (saving) return;
    if (!form.legalName.trim()) { toast.error("Η επωνυμία είναι υποχρεωτική."); return; }
    if (!/^\d{9}$/.test(form.taxId.trim())) { toast.error("Το ΑΦΜ πρέπει να έχει 9 ψηφία."); return; }
    setSaving(true);
    try {
      await platformConfigAPI.update(form);
      toast.success("Τα στοιχεία αποθηκεύτηκαν.");
      await load();
    } catch (err) {
      console.error("Save platform config error:", err);
      const msg = err.response?.data?.error || "Σφάλμα αποθήκευσης";
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <>
        <PageHeader title="Στοιχεία Πλατφόρμας" />
        <Card><div style={{ padding: 24, color: "#6B7280" }}>Φόρτωση...</div></Card>
      </>
    );
  }

  return (
    <>
      <PageHeader title="Στοιχεία Πλατφόρμας" subtitle="Επιχειρησιακά στοιχεία DocNow" />

      <Card title="Νομικά Στοιχεία">
        <div style={{ padding: 16, display: "grid", gap: 12 }}>
          <FormField label="Επωνυμία *"><input value={form.legalName} onChange={set("legalName")} placeholder="DOCNOW E.E." /></FormField>
          <FormField label="ΑΦΜ *"><input value={form.taxId} onChange={set("taxId")} placeholder="803284374" maxLength={9} /></FormField>
          <FormField label="ΓΕΜΗ"><input value={form.gemi} onChange={set("gemi")} placeholder="193781603000" /></FormField>
        </div>
      </Card>

      <Card title="Διεύθυνση Έδρας">
        <div style={{ padding: 16, display: "grid", gap: 12 }}>
          <FormField label="Διεύθυνση"><input value={form.addressLine} onChange={set("addressLine")} /></FormField>
          <FormField label="Πόλη"><input value={form.city} onChange={set("city")} /></FormField>
          <FormField label="Τ.Κ."><input value={form.postalCode} onChange={set("postalCode")} /></FormField>
          <FormField label="Χώρα"><input value={form.country} onChange={set("country")} maxLength={2} /></FormField>
        </div>
      </Card>

      <Card title="Επικοινωνία">
        <div style={{ padding: 16, display: "grid", gap: 12 }}>
          <FormField label="Τηλέφωνο"><input value={form.phone} onChange={set("phone")} placeholder="+30 210 123 4567" /></FormField>
          <FormField label="Email"><input value={form.email} onChange={set("email")} placeholder="info@docnow.gr" type="email" /></FormField>
        </div>
      </Card>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <ActionBtn variant="primary" onClick={save} disabled={saving}>
          {saving ? "Αποθήκευση..." : "Αποθήκευση"}
        </ActionBtn>
      </div>
    </>
  );
}
